import * as React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Container from "@mui/material/Container";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LookupServieURL } from "../../../config/config";
import {
  DataGridPro,
  GridActionsCellItem,
  GridToolbarFilterButton,
  GridPaginationModel,
  GridColDef,
  GridToolbarContainer,
  GridToolbarExport,
  GridLogicOperator,
  getGridStringOperators,
} from "@mui/x-data-grid-pro";
import { DataGrid } from "../../util/DataGrid";
import { getApiCall,postApiCall } from "../../../services/apiHelper";
import { GridFilterModel } from "@mui/x-data-grid";
import {  CircularProgress  } from "@mui/material";
import { useResizeDetector } from "react-resize-detector";


export interface ObjAppraisalFirm {
  id: string;
  name: string;
  appraisalFirm: string;
  email: string;
  status: string;
  createdBy: string;
  created: string;
  lastModifiedBy: string;
  lastModified: string;
  region : string;
}

interface AppraisalFirmDashboardPayload {
  filters: GridFilterModel[];
  first: number;
  globalFilter: any;
  rows: number;
  sortOrder: number;
}

export const AppraiserFirmDashboard = () => {
  const navigate = useNavigate();
  const [value, setValue] = React.useState("1");
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  const [appraiserFirmData, setAppraiserFirmData]= useState<ObjAppraisalFirm[]>([]);
  const [pageSize, setPageSize] = useState<number>(10);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: pageSize,
  });
  const [filterModel, setFilterModel] = React.useState<GridFilterModel>({
    items: [],
    logicOperator:GridLogicOperator.And
  });
  const [loading, setLoading] = useState<boolean>(true);
  const [rowCount, setRowCount] = useState<number>(0);
  const [appraiserDataCount, setAppraiserDataCount]  = useState<number>(1);

  const fetchData = async (paginationModel: GridPaginationModel, filterModel: GridFilterModel) => {
    await GetAppraisals(paginationModel, filterModel).then(
      (data: any) => {        
        setAppraiserFirmData(data?.result?.externalAppraiser);
        setRowCount(data.result.rowCount);
        setLoading(false);
      }
    );
  };

  const GetAppraisals = async (paginationModel: GridPaginationModel, filterModel: GridFilterModel) => {

    var firmFilterArr: any[] = [];
    firmFilterArr = filterModel?.items?.map((firmFilter: any) => {
      if (firmFilter?.value != undefined) {
        return {
          identity: firmFilter?.field,
          matchMode: firmFilter?.operator,
          value: firmFilter?.value,
        };
      }
    });

    var url = LookupServieURL + "/externalappraisers/GetAllExternalAppraiserDashboard";
    var payload = {
        filters: firmFilterArr,
        first: paginationModel.pageSize * paginationModel.page,
        globalFilter: null,
        rows: paginationModel.pageSize,
        filterConditionalOperator: filterModel.logicOperator,
        sortOrder: 1
      };     
      if(payload.filters.length == 0){
        payload = {...payload,filterConditionalOperator:GridLogicOperator.And}
      } 
    const response = postApiCall(url, payload, "LookupService").then((data: any) => data);
    return response;
  };

  useEffect(() => {
    fetchData(paginationModel, filterModel);
  }, [paginationModel, filterModel]);
  const { width,ref } = useResizeDetector();
  const [columnWidths,setColumnWidths] = useState<any>({});

  useEffect(()=>{
    if(width){
      const newColumnWidths = {
        column1:width * 0.1,
        column2:width * 0.15
      };
      setColumnWidths(newColumnWidths);
    }
  },[width]);
  const formatNumber = (params:any) => {
    if(params.value !== null)
      return<div style={{textAlign:'right',width:'85%',paddingRight:'5px'}}>
        {params.value.toLocaleString('en-US')}
      </div>
     ;
  }


  const columns: GridColDef[] = [
    {
      field: "action",
      headerName: "Actions",
      sortable: false,
      filterable: false,
      disableExport: true,
      renderCell: (cellValues) => {
        const onEditClick = (e: any) => {
          e.stopPropagation();
          navigate("/appraiserfirm/" + "edit/" + cellValues.id);          
        };

        const onViewClick = (e: any) => {
          e.stopPropagation();
          navigate("/appraiserfirm/" + "view/" + cellValues.id);          
        };
        return (
          <>
            <GridActionsCellItem
              sx={{
                color: "#253746",
              }}
              icon={<VisibilityIcon />}
              label="View"
              onClick={(event) => {
                onViewClick(event);
              }}
            />
            <GridActionsCellItem
              sx={{
                color: "#253746",
              }}
              icon={<EditIcon />}
              label="Edit"
              onClick={(event) => {
                onEditClick(event);
              }}
            />
          </>
        );
      },width:columnWidths.column1 || 100
    },
    { field: "id", headerName: "Appraiser Firm Id",
    filterOperators: getGridStringOperators().filter(
      (operator) => operator.value === "contains"
    ) ,width:columnWidths.column2 || 100 },
    { field: "name", headerName: "External Appraiser Name", width:columnWidths.column2 || 100,
    filterOperators: getGridStringOperators().filter(
      (operator) => operator.value === "contains"
    )   },
    { field: "appraisalFirm", headerName: "Appraiser Firm", width:columnWidths.column2 || 100 ,
    filterOperators: getGridStringOperators().filter(
      (operator) => operator.value === "contains"
    )  },
    { field: "email", headerName: "Email Address", width:columnWidths.column2 || 100 ,
    filterOperators: getGridStringOperators().filter(
      (operator) => operator.value === "contains"
    )  },
    { field: "region", headerName: "Region", width:columnWidths.column2 || 100,
    filterOperators: getGridStringOperators().filter(
      (operator) => operator.value === "contains"
    )   },
    { field: "status", headerName: "Status", width:columnWidths.column2 || 100 ,
    filterOperators: getGridStringOperators().filter(
      (operator) => operator.value === "contains"
    )  },
  ];

  const handelPaginationModel = (e: GridPaginationModel) => {       
    let dataCount = e.page * e.pageSize;
    setAppraiserDataCount(dataCount);     
    setPaginationModel(e);
    fetchData(e, filterModel);    
  };

  const handelFilterModelChange = (model: any) => {
    // const count = model?.items.length != 0 ? Object.keys(model?.items[0]).length-1 : 0;
    // if (count === 4) {
    setFilterModel(model);   
    // }
  };

  const CustomToolbar = () => {
    return (
      <GridToolbarContainer>
        <GridToolbarExport />
        <GridToolbarFilterButton />
      </GridToolbarContainer>
    );
  };


  return (
    <Container maxWidth={false} className="dashboard-wrap">
      {loading && (
        <div className="overlaySpinner">
          <CircularProgress />
        </div>
      )}
      <Box sx={{ width: "100%", typography: "body1" }}>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Button sx={{textTransform:"none"}}
              className="head-action-btn text-right"
              variant="contained"
              color="success"
              onClick={() => navigate("/appraiserfirm/new")}
            >
              <AddIcon />
              New Appraiser Firm
            </Button>
            <TabList
              onChange={handleChange}
              aria-label="Appraisals Tab"
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab label="All Items" value="1"  sx={{textTransform:'capitalize'}}/>              
            </TabList>
          </Box>
          <TabPanel ref={ref} value="1">
          {
              <DataGrid data-testId='datagridfund'
                rows={appraiserFirmData}
                rowCount={rowCount}
                columns={columns}
                paginationModel={paginationModel}
                PaginationModelChange={handelPaginationModel}
                filterModel={filterModel}
                loading={loading}
                filterModelChange={(model: GridFilterModel) => handelFilterModelChange(model)}
                customToolbar={CustomToolbar}
              />
            }
          </TabPanel>          
        </TabContext>
      </Box>
    </Container>
  );
};

